export const server = "https://multivendor-backend-blond.vercel.app/api/v2";
export const backend_url = "https://multivendor-backend-blond.vercel.app/";
